import React from "react";

const DisabledPage = () => (
  <div style={{
    minHeight: "100vh",
    background: "linear-gradient(120deg, #f5f7fa 0%, #c3cfe2 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, 'sans-serif'"
  }}>
    <div style={{
      background: "#fff",
      borderRadius: "32px",
      boxShadow: "0 12px 40px rgba(60,60,120,0.18)",
      padding: "56px 40px",
      maxWidth: "480px",
      textAlign: "center",
      animation: "fadeIn 1.2s cubic-bezier(.4,0,.2,1)"
    }}>
      <div style={{
        marginBottom: "32px",
        display: "flex",
        justifyContent: "center"
      }}>
        <svg width="90" height="90" viewBox="0 0 90 90" fill="none">
          <circle cx="45" cy="45" r="43" fill="#e9ecef" stroke="#dee2e6" strokeWidth="4"/>
          <path d="M45 28v24" stroke="#495057" strokeWidth="4" strokeLinecap="round"/>
          <circle cx="45" cy="62" r="4" fill="#495057"/>
        </svg>
      </div>
      <h1 style={{
        fontSize: "2.2rem",
        color: "#212529",
        marginBottom: "16px",
        fontWeight: 700,
        letterSpacing: "0.02em"
      }}>
        Service Unavailable
      </h1>
      <p style={{
        color: "#495057",
        fontSize: "1.12rem",
        marginBottom: "36px",
        lineHeight: 1.7
      }}>
        This service is currently inaccessible.<br />
        If you require further information or support, please contact our team at <a href="mailto:support@truyon.com" style={{ color: "#0056b3", textDecoration: "underline", fontWeight: 500 }}>support@truyon.com</a>.
      </p>
      <div style={{
        display: "flex",
        justifyContent: "center"
      }}>
        <div className="loader" style={{
          width: "40px",
          height: "40px",
          border: "4px solid #e9ecef",
          borderTop: "4px solid #0056b3",
          borderRadius: "50%",
          animation: "spin 1s linear infinite"
        }} />
      </div>
      <style>
        {`
          @keyframes fadeIn {
            0% { opacity: 0; transform: translateY(40px);}
            100% { opacity: 1; transform: translateY(0);}
          }
          @keyframes spin {
            0% { transform: rotate(0deg);}
            100% { transform: rotate(360deg);}
          }
        `}
      </style>
    </div>
  </div>
);

export default DisabledPage;